<template>
  <div class="container m-5">
    <div
      class="row"
    >
      <div
        class="col-lg-12 col-xs-12"
      >
        <span
          class="f18 font-weight-bold"
        >
          Selecione um arquivo para adicionar dados nas aplicações da vaga.
        </span>
      </div>
      <div
        class="col-lg-12 col-xs-12 mt-3"
      >
        <label class="input-group-btn pointer">
          <span class="btn btn-primary pointer">
            Carregar Arquivo
            <input
              type="file"
              ref="file"
              v-on:change="sendFile()"
              id="apply_data"
              name="apply_data"
              style="display: none"
              multiple
            />
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["job"],
  methods: {
    sendFile() {
      this.file = this.$refs.file.files[0];
      this.name = this.$refs.file.files[0].name;
      let formData = new FormData();
      let type_file = this.name.toLowerCase().split(".");

      if (
        ["csv"].includes(type_file[type_file.length - 1]) ==
        false
      ) {
        this.$toast.error(
          "Formato do arquivo inválido, aceitamos apenas csv"
        );
        return;
      }

      if (this.file.size > 1024 * 1024) {
        alert("Arquivo muito grande (> 1MB)");
        return;
      }
      formData.append("file", this.file);
      formData.append("job_id", this.job.id);
      axios
        .post("/recruiters/csv_applies", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (data) {
          if (!data.data.status) {
            alert(
              "Formato de arquivo inválido, tente novamente com o formato csv"
            );
            return;
          }
          eventBus.$emit("closeApplyUploadDialog");
        })
        .catch((error) => {});
      return;
    }
  },
}
</script>
    
